// Fore Kazık Mock Data
// Fore kazık imalatı, süreç takibi ve metraj

export const foreKaziklar = [
    {
        id: 'fk-001',
        kazikNo: 'FK-A-001',
        baslangicTarihi: '2025-12-20',
        bitisTarihi: '2025-12-21',
        blok: 'A Blok',
        konum: 'Aksis A1',
        cap: 80,
        birim: 'cm',
        derinlik: 25,
        derinlikBirim: 'm',
        betonSinifi: 'C30/37',
        betonMiktari: 12.6,
        demirMiktari: 1.2,
        tedarikci: 'Özkaya Fore Kazık',
        tedarikciFirmaId: 'f-020',
        birimFiyat: 45000,
        toplamFiyat: 45000,
        durum: 'tamamlandi',
        testDurumu: 'basarili',
        testTarihi: '2025-12-28',
        insaatId: 'c-001',
        not: 'PDA testi yapıldı, kabul edildi',
        createdAt: '2025-12-20T06:00:00Z',
        updatedAt: '2025-12-28T15:00:00Z',
    },
    {
        id: 'fk-002',
        kazikNo: 'FK-A-002',
        baslangicTarihi: '2025-12-21',
        bitisTarihi: '2025-12-22',
        blok: 'A Blok',
        konum: 'Aksis A2',
        cap: 80,
        birim: 'cm',
        derinlik: 24,
        derinlikBirim: 'm',
        betonSinifi: 'C30/37',
        betonMiktari: 12.1,
        demirMiktari: 1.1,
        tedarikci: 'Özkaya Fore Kazık',
        tedarikciFirmaId: 'f-020',
        birimFiyat: 45000,
        toplamFiyat: 43200,
        durum: 'tamamlandi',
        testDurumu: 'basarili',
        testTarihi: '2025-12-29',
        insaatId: 'c-001',
        not: 'Sonik test yapıldı',
        createdAt: '2025-12-21T06:00:00Z',
        updatedAt: '2025-12-29T14:00:00Z',
    },
    {
        id: 'fk-003',
        kazikNo: 'FK-A-003',
        baslangicTarihi: '2025-12-23',
        bitisTarihi: '2025-12-24',
        blok: 'A Blok',
        konum: 'Aksis B1',
        cap: 100,
        birim: 'cm',
        derinlik: 28,
        derinlikBirim: 'm',
        betonSinifi: 'C35/45',
        betonMiktari: 22.0,
        demirMiktari: 1.8,
        tedarikci: 'Özkaya Fore Kazık',
        tedarikciFirmaId: 'f-020',
        birimFiyat: 55000,
        toplamFiyat: 61600,
        durum: 'tamamlandi',
        testDurumu: 'basarili',
        testTarihi: '2025-12-30',
        insaatId: 'c-001',
        not: 'Asansör çukuru ana kazığı',
        createdAt: '2025-12-23T06:00:00Z',
        updatedAt: '2025-12-30T16:00:00Z',
    },
    {
        id: 'fk-004',
        kazikNo: 'FK-A-004',
        baslangicTarihi: '2026-01-10',
        bitisTarihi: null,
        blok: 'A Blok',
        konum: 'Aksis B2',
        cap: 80,
        birim: 'cm',
        derinlik: 26,
        derinlikBirim: 'm',
        betonSinifi: 'C30/37',
        betonMiktari: 13.1,
        demirMiktari: 1.2,
        tedarikci: 'Özkaya Fore Kazık',
        tedarikciFirmaId: 'f-020',
        birimFiyat: 45000,
        toplamFiyat: 46800,
        durum: 'devam',
        testDurumu: 'bekliyor',
        testTarihi: null,
        insaatId: 'c-001',
        not: 'Delme işlemi devam ediyor',
        createdAt: '2026-01-10T06:00:00Z',
        updatedAt: '2026-01-10T18:00:00Z',
    },
    {
        id: 'fk-005',
        kazikNo: 'FK-B-001',
        baslangicTarihi: '2026-01-05',
        bitisTarihi: '2026-01-06',
        blok: 'B Blok',
        konum: 'Aksis A1',
        cap: 65,
        birim: 'cm',
        derinlik: 20,
        derinlikBirim: 'm',
        betonSinifi: 'C25/30',
        betonMiktari: 6.6,
        demirMiktari: 0.8,
        tedarikci: 'Mega Zemin',
        tedarikciFirmaId: 'f-021',
        birimFiyat: 35000,
        toplamFiyat: 28000,
        durum: 'tamamlandi',
        testDurumu: 'bekliyor',
        testTarihi: null,
        insaatId: 'c-002',
        not: 'Test bekleniyor',
        createdAt: '2026-01-05T07:00:00Z',
        updatedAt: '2026-01-06T16:00:00Z',
    },
];

// Kazık çapları
export const kazikCaplari = [
    { key: 65, label: 'Ø65 cm', aciklama: 'Hafif yapılar' },
    { key: 80, label: 'Ø80 cm', aciklama: 'Standart' },
    { key: 100, label: 'Ø100 cm', aciklama: 'Ağır yapılar' },
    { key: 120, label: 'Ø120 cm', aciklama: 'Özel projeler' },
    { key: 150, label: 'Ø150 cm', aciklama: 'Köprü, vb.' },
];

// Durum seçenekleri
export const kazikDurumlari = [
    { key: 'planlandi', label: 'Planlandı', color: 'info' },
    { key: 'devam', label: 'Devam Ediyor', color: 'warning' },
    { key: 'tamamlandi', label: 'Tamamlandı', color: 'success' },
    { key: 'test_bekliyor', label: 'Test Bekleniyor', color: 'warning' },
];

// Test durumları
export const testDurumlari = [
    { key: 'bekliyor', label: 'Bekliyor', color: 'warning' },
    { key: 'basarili', label: 'Başarılı', color: 'success' },
    { key: 'basarisiz', label: 'Başarısız', color: 'error' },
];

// İstatistikler
export const getForeKazikStats = (insaatId) => {
    const filtered = insaatId
        ? foreKaziklar.filter(s => s.insaatId === insaatId)
        : foreKaziklar;

    const toplamKazik = filtered.length;
    const tamamlanan = filtered.filter(s => s.durum === 'tamamlandi').length;
    const devamEden = filtered.filter(s => s.durum === 'devam').length;
    const toplamMetraj = filtered.reduce((acc, s) => acc + s.derinlik, 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);
    const testBasarili = filtered.filter(s => s.testDurumu === 'basarili').length;

    return {
        toplamKazik,
        tamamlanan,
        devamEden,
        toplamMetraj,
        toplamMaliyet,
        testBasarili,
        testOrani: toplamKazik > 0 ? Math.round((testBasarili / toplamKazik) * 100) : 0,
    };
};

// Helper: insaata göre filtrele
export const getForeKazikByInsaat = (insaatId) => {
    if (!insaatId) return foreKaziklar;
    return foreKaziklar.filter(s => s.insaatId === insaatId);
};
